export default __webpack_public_path__ + "static/media/182.8a1b4e35.jpg";